import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import StyledHtmlContent from './common/StyledHtmlContent';

const FeaturedGrid: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <section id="featured" className="bg-dark_gray py-8 sm:py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-8 text-center justify-items-center max-w-4xl mx-auto">
            
            <Link to="/casino" className="flex flex-col items-center rounded-xl overflow-hidden border-2 border-red-500 bg-black hover:scale-105 transition-transform duration-300">
              <img src="/card-1.png" alt="Casino" className="w-full h-[16rem] sm:h-[15rem] md:h-[19rem] object-cover" />
            </Link>

            <Link to="/lottery" className="flex flex-col items-center transition rounded-xl overflow-hidden border-2 border-red-500 bg-black hover:scale-105 transition-transform duration-300">
              <img src="/card-2.png" alt="Game Bài" className="w-full h-[16rem] sm:h-[15rem] md:h-[19rem] object-cover" />
            </Link>

            <Link to="/sports" className="flex flex-col items-center transition rounded-xl overflow-hidden border-2 border-red-500 bg-black hover:scale-105 transition-transform duration-300">
              <img src="/card-3.png" alt="Thể Thao" className="w-full h-[16rem] sm:h-[15rem] md:h-[19rem] object-cover" />
            </Link>

          </div>
        </div>
      </section>
      <section className="bg-dark_gray text-white py-8 sm:py-16 px-4">
        <div className="max-w-[93rem] mx-auto text-center">
          <h1 className="text-xl sm:text-2xl md:text-3xl font-bold uppercase mb-4 sm:mb-6 bg-gradient-to-r from-orange-500 via-red-500 via-pink-500 via-purple-600 to-blue-500 bg-200 bg-clip-text text-transparent animate-gradient-x">
          {t('home.home_title')}
          </h1>
          <div className="bg-dark_gray border border-[#ff3d00] rounded-xl p-4 sm:p-6 md:p-[2rem] text-left max-h-[55rem] overflow-y-auto scrollbar-thin scrollbar-thumb-orange-500 scrollbar-track-gray-900 shadow-[0_0_20px_4px_#ff3d00]">
            <p className="mb-6 sm:mb-[2.5rem] text-gray-200 text-base sm:text-xl">
              {/* <pre className="whitespace-pre-wrap break-words mb-10 overflow-x-auto">
                {t('home.home_content')}
              </pre> */}
              <h2 className="text-3xl sm:text-3xl font-bold text-orange-500 mb-3 sm:mb-4">
                {t('scroller.u888_overview_title')}
              </h2>
              <div className="whitespace-pre-wrap break-words overflow-x-auto">
                <StyledHtmlContent html={t('scroller.u888_overview')} />
              </div>
            </p>

            <div className="w-[95%] sm:w-[85%] mx-auto mb-[15px]">
              <img
                src="/u888-banner.jpg"
                alt="U888 Promotion"
                className="rounded-md w-full h-auto"
              />
              <label className="block text-center italic mt-2 text-base sm:text-xl">
                {t('home.image_hint')}
              </label>
            </div>

            <p className="mb-[2.5rem] text-gray-200 text-xl">
              <h2 className="text-3xl font-bold text-orange-500 mb-4">
                {t('scroller.u888_about_title')}
              </h2>
              <div className="whitespace-pre-wrap break-words overflow-x-auto">
                <StyledHtmlContent html={t('scroller.u888_about')} />
              </div>
            </p>

            <p className="mb-[2.5rem] text-gray-200 text-xl">
              <h2 className="text-3xl font-bold text-orange-500 mb-4">
                {t('scroller.u888_license_info_title')}
              </h2>
              <div className="whitespace-pre-wrap break-words overflow-x-auto">
                <StyledHtmlContent html={t('scroller.u888_license_info')} />
              </div>
            </p>

            <div className="w-[85%] mx-auto mb-[15px]">
              <img
                src="/u888-banner.jpg"
                alt="U888 Promotion"
                className="rounded-md w-full h-auto"
              />
              <label className="block text-center italic mt-2 text-xl">
                {t('home.image_hint')}
              </label>
            </div>
            <p className="mb-[2.5rem] text-gray-200 text-xl">
              <h2 className="text-3xl font-bold text-orange-500 mb-4">
                {t('scroller.u888_access_info_title')}
              </h2>
              <div className="whitespace-pre-wrap break-words overflow-x-auto">
                <StyledHtmlContent html={t('scroller.u888_access_info')} />
              </div>
            </p>
            <p className="mb-[2.5rem] text-gray-200 text-xl">
              <h2 className="text-3xl font-bold text-orange-500 mb-4">
                {t('scroller.u888_ui_experience_title')}
              </h2>
              <div className="whitespace-pre-wrap break-words overflow-x-auto">
                <StyledHtmlContent html={t('scroller.u888_ui_experience')} />
              </div>
            </p>
            <p className="mb-[2.5rem] text-gray-200 text-xl">
              <h2 className="text-3xl font-bold text-orange-500 mb-4">
                {t('scroller.u888_security_transactions_title')}
              </h2>
              <pre className="whitespace-pre-wrap break-words overflow-x-auto">
                {t('scroller.u888_security_transactions')}
              </pre>
            </p>

            <p className="mb-[2.5rem] text-gray-200 text-xl">
              <h2 className="text-3xl font-bold text-orange-500 mb-4">
                {t('scroller.u888_high_quality_title')}
              </h2>
              <pre className="whitespace-pre-wrap break-words overflow-x-auto">
                {t('scroller.u888_high_quality')}
              </pre>
            </p>
            <p className="mb-[2.5rem] text-gray-200 text-xl">
              <h2 className="text-3xl font-bold text-orange-500 mb-4">
                {t('scroller.u888_game_update_title')}
              </h2>
              <div className="whitespace-pre-wrap break-words overflow-x-auto">
                <StyledHtmlContent html={t('scroller.u888_game_update')} />
              </div>
            </p>
            <p className="mb-[2.5rem] text-gray-200 text-xl">
              <h2 className="text-3xl font-bold text-orange-500 mb-4">
                {t('scroller.u888_tradition_title')}
              </h2>
              <div className="whitespace-pre-wrap break-words overflow-x-auto">
                <StyledHtmlContent html={t('scroller.u888_tradition')} />
              </div>
            </p>
            <p className="mb-[2.5rem] text-gray-200 text-xl">
              <h2 className="text-3xl font-bold text-orange-500 mb-4">
                {t('scroller.u888_lottery_section_title')}
              </h2>
              <div className="whitespace-pre-wrap break-words overflow-x-auto">
                <StyledHtmlContent html={t('scroller.u888_lottery_section_description')} />
              </div>
            </p>
            <p className="mb-[2.5rem] text-gray-200 text-xl">
              <h2 className="text-3xl font-bold text-orange-500 mb-4">
                {t('scroller.u888_fish_shooting_game_title')}
              </h2>
              <div className="whitespace-pre-wrap break-words overflow-x-auto">
                <StyledHtmlContent html={t('scroller.u888_fish_shooting_game_description')} />
              </div>
            </p>
            <p className="mb-[2.5rem] text-gray-200 text-xl">
              <h2 className="text-3xl font-bold text-orange-500 mb-4">
                {t('scroller.u888_fish_shooting_rewards_title')}
              </h2>
              <div className="whitespace-pre-wrap break-words overflow-x-auto">
                <StyledHtmlContent html={t('scroller.u888_fish_shooting_rewards_description')} />
              </div>
            </p>
            <p className="mb-[2.5rem] text-gray-200 text-xl">
              <h2 className="text-3xl font-bold text-orange-500 mb-4">
                {t('scroller.u888_cockfighting_section_title')}
              </h2>
              <pre className="whitespace-pre-wrap break-words overflow-x-auto">
                {t('scroller.u888_cockfighting_section_description')}
              </pre>
            </p>
            <p className="mb-[2.5rem] text-gray-200 text-xl">
              <h2 className="text-3xl font-bold text-orange-500 mb-4">
                {t('scroller.u888_registration_guide_title')}
              </h2>
              <div className="whitespace-pre-wrap break-words overflow-x-auto">
                <StyledHtmlContent html={t('scroller.u888_registration_guide_description')} />
              </div>
            </p>
            <p className="mb-[2.5rem] text-gray-200 text-xl">
              <div className="whitespace-pre-wrap break-words overflow-x-auto">
                <h3 className="text-2xl font-semibold text-orange-400 mb-3">
                  {t('scroller.u888_registration_and_login_guide_title')}
                </h3>
                <div className="mb-6">
                  <StyledHtmlContent html={t('scroller.u888_registration_and_login_guide_content')} />
                </div>
              </div>
            </p>
            <p className="mb-[2.5rem] text-gray-200 text-xl">
              <div className="whitespace-pre-wrap break-words overflow-x-auto">
                <h3 className="text-2xl font-semibold text-orange-400 mb-3">
                  {t('scroller.u888_login_guide_title')}
                </h3>
                <div className="mb-6">
                  <StyledHtmlContent html={t('scroller.u888_login_guide_content')} />
                </div>
              </div>
            </p>
            <p className="mb-[2.5rem] text-gray-200 text-xl">
              <div className="whitespace-pre-wrap break-words overflow-x-auto">
                <h3 className="text-2xl font-semibold text-orange-400 mb-3">
                  {t('scroller.u888_download_app_title')}
                </h3>
                <div className="mb-6">
                  <StyledHtmlContent html={t('scroller.u888_download_app_content')} />
                </div>
              </div>
            </p>
            <p className="mb-[2.5rem] text-gray-200 text-xl">
              <h2 className="text-3xl font-bold text-orange-500 mb-4">
                {t('scroller.u888_content_2_main_title')}
              </h2>
            </p>
            {[...Array(13)].map((_, i) => {
              const content = t(`scroller.u888_content_${i+1}_content`);
              const hasLinks = content.includes('<a ');
              
              return (
                <div key={`u888_content_${i+1}`} className="mb-[2.5rem] text-gray-200 text-xl">
                  <h2 className="text-3xl font-bold text-orange-500 mb-4">
                    {t(`scroller.u888_content_${i+1}_title`)}
                  </h2>
                  {hasLinks ? (
                    <div className="whitespace-pre-wrap break-words overflow-x-auto">
                      <StyledHtmlContent html={content} className="text-gray-200" />
                    </div>
                  ) : (
                    <pre className="whitespace-pre-wrap break-words overflow-x-auto">
                      {content}
                    </pre>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section> 
    </>
  );
};

export default FeaturedGrid; 